/**
 * Converts a base64 string to an ArrayBuffer.
 *
 * @param base64 - Base64-encoded string
 * @returns ArrayBuffer containing the decoded binary data, or empty ArrayBuffer if decoding fails
 *
 * @remarks
 * This utility is used to decode binary file content that comes from protobuf
 * `bytes` fields. During JSON/gRPC-Web transport, protobuf bytes are encoded
 * as base64 strings. This function decodes them back to binary data.
 *
 * If the base64 string is invalid, the function logs an error and returns an
 * empty ArrayBuffer to prevent component crashes.
 */
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  try {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  } catch (error) {
    console.warn('Failed to decode base64 content:', error);
    return new ArrayBuffer(0);
  }
}
